import { gql } from '@apollo/client';

export const GET_PONENCIA_ID = gql`
  {
    getPonenciaId @client
  }
`;

export const GET_PONENCIA = gql`
  query getPonencia($id: ID!) {
    getPonencia(id: $id) {
      _id
      titulo
      resumen
      fichero
    }
  }
`;

export const GET_PONENCIAS = gql`
  query getPonencias($paginate: getPonenciasPaginate!) {
    getPonencias(paginate: $paginate) {
      ponencias {
        node {
          _id
          titulo
          resumen
          fichero
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const SEARCH_PONENCIAS = gql`
  query searchPonencias($paginate: searchPonenciasPaginate!) {
    searchPonencias(paginate: $paginate) {
      ponencias {
        node {
          _id
          titulo
          resumen
          fichero
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_PONENCIA = gql`
  mutation createPonencia($input: CreatePonenciaInput!) {
    createPonencia(input: $input) {
      _id
      titulo
      resumen
      fichero
      code
      success
      message
    }
  }
`;

export const UPDATE_PONENCIA = gql`
  mutation updatePonencia($input: UpdatePonenciaInput) {
    updatePonencia(input: $input) {
      _id
      titulo
      resumen
      fichero
      code
      success
      message
    }
  }
`;

export const REMOVE_PONENCIA = gql`
  mutation removePonencia($input: DeletePonenciaInput!) {
    removePonencia(input: $input) {
      code
      success
      message
    }
  }
`;
